module.exports = __webpack_public_path__ + "img/banner-index1.bb4c4a68.jpg";